import React, { ReactNode } from 'react';
import useStyles from '../Dropdown.style';

export const DropdownPlaceholder = ({ placeholder, value }: { placeholder: ReactNode, value: string | string[] }) => {
  const c = useStyles({ value });
  return <span className={c.placeholder}>{placeholder}</span>;
};
